<script setup lang="ts">
  defineProps({
    header: String,
    header_type: { type: String },
    content: String,
    items: Array,
  });
</script>
<template>
  <div class="container configurators-container">
    <div class="configurators-wrapper">
      <div class="info">
        <SegmentHeading v-if="header" larger :type="header_type || 'h2'">{{ header }}</SegmentHeading>
        <p v-if="content" class="info-text" v-html="content" />
      </div>
      <ul class="link-list-wrapper" v-for="item in items">
        <li>
          <visitor-link :href="item.link" target="_blank" class="link">
            <div class="icon-wrapper">
              <IconArrowRightCircle />
            </div>
            {{ item.content }}
          </visitor-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .configurators-container {
    margin-bottom: 120px;

    .configurators-wrapper {
      background-color: var(--color-white);
      border-radius: 5px;

      .info {
        max-width: 800px;

        .info-text {
          margin-top: 30px;
        }
      }

      .link-list-wrapper {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 40px;
        list-style: none;

        .link {
          display: flex;
          color: var(--color-black);
          font-size: 18px;
          gap: 0.5rem;
          font-weight: 500;
          text-decoration: underline;
          transition: var(--transition-primary);
          line-height: 1.5rem;
          width: fit-content;

          &:hover {
            color: var(--primary-color);
          }

          .icon-wrapper .arrow-icon {
            font-size: 14px;
          }

        }
      }
    }
  }

  @media (max-width: 992px) {
    .configurators-container {
      margin: 1rem auto 3rem;
      width: 96%;
    }
  }
</style>
